<template>
    <div>
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
        </base-header>
        <a-drawer v-if="drawerVisible" title="" :width="480" placement="right" @close="onClose" :visible="drawerVisible">

            <br>
            
            <div v-if="type == 'a'">
                <base-input label="Select Accounts on the List">
                    <br/>
                    <a-select v-model="accountIds" mode="multiple" showSearch placeholder="Search Account" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :notFoundContent="fetching ? undefined : null" @search="handleSearch">
                        <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                        <a-select-option v-for="option in accountOptions" :key="option.id" :value="option.id">{{option.account_name}}</a-select-option>
                    </a-select>
                </base-input>
            </div>

            <div v-if="type == 's'">
                <h6 class="heading-small text-muted pb-3">Select sites where updated version will be deployed</h6>
                <ul class="list-group list-group-flush" style="width: 100%">
                    <li class="list-group-item" style="font-size: 14px; height: 55px; background-color: #f7f7f7">
                        <div class="row">
                            <div class="col-md-6">
                                SITE LIST
                            </div>
                            <div class="col-md-6">
                                <!-- @change="onCheckAllChangeAccess" :checked="selectedAccessRights.length == 12" -->
                                <a-checkbox class="float-right" @change="onCheckAllUpdateSiteList" :checked="siteIds.length == sites.length" />
                            </div>
                         </div>
                    </li>

                    <li class="list-group-item" style="font-size: 14px" v-for="(site, index) in sites" :key=index>
                         <div class="row">
                             <div class="col-md-6">
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{site.name}}
                            </div>
                            <div class="col-md-6">
                                <a-checkbox data-id="system_module.name" @change="onCheckUpdateSiteList(site.id)" :checked="siteIds.includes(site.id)" class="float-right"/>
                            </div>
                         </div>
                    </li>
                </ul>

                <div class="float-right" style="position: absolute; bottom: 20px; right: 20px;">
                    <button class="btn btn-primary" @click.prevent="onClose">Cancel</button>
                    <button class="btn btn-success" @click="updateSelectedSite">Save</button>
                </div>
            </div>

            <div v-if="type == 't'">
                <h6 class="heading-small text-muted pb-3">Select terminals where updated version will be deployed</h6>
                <ul class="list-group list-group-flush" style="width: 100%">
                    <li class="list-group-item" style="font-size: 14px; height: 55px; background-color: #f7f7f7">
                        <div class="row">
                            <div class="col-md-6">
                                TERMINAL LIST
                            </div>
                            <div class="col-md-6">
                                <!-- @change="onCheckAllChangeAccess" :checked="selectedAccessRights.length == 12" -->
                                <a-checkbox class="float-right" @change="onCheckAllUpdateTerminalList()" :checked="terminalIds.length == terminals.length" />
                            </div>
                         </div>
                    </li>

                    <li class="list-group-item" style="font-size: 14px" v-for="(terminal, index) in terminals" :key=index>
                         <div class="row">
                             <div class="col-md-6">
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{terminal.name}}
                            </div>
                            <div class="col-md-6">
                                <a-checkbox data-id="system_module.name" @change="onCheckUpdateTerminalList(terminal.id)" :checked="terminalIds.includes(terminal.id)" class="float-right"/>
                            </div>
                         </div>
                    </li>
                </ul>

                <div class="float-right" style="position: absolute; bottom: 20px; right: 20px;">
                    <button class="btn btn-primary" @click.prevent="onClose">Cancel</button>
                    <button class="btn btn-success" @click="updateSelectedTerminal()">Save</button>
                </div>
            </div>

        </a-drawer>
        <div class="container-fluid mt--7">
            <div class="card mb-3">
                <div class="row no-gutters" style="min-height: 56vh; overflow: auto;">
                    <!-- <div class="col-md-3" style="border-right: 1px solid #e0e0e0">
                        <div class="row" style="margin: 2px;">
                            <div class="col-md-6 mt-2">
                                <h6 class="heading-small text-muted pb-3">Release List</h6> 
                            </div>
                            <div class="col-md-6 mt-2">
                                <button class="float-right btn btn-sm btn-primary"> <span class="fa fa-sync" /> </button>
                            </div>
                        </div>
                    </div> -->
                    <div class="col-md-12" style="height: 100vh;">
                        <!-- <div class="row" style="margin: 2px;">
                            <div class="col-md-6 mt-2">
                                <h6 class="heading-small text-muted pb-3">Release List</h6> 
                            </div>
                            <div class="col-md-6 mt-2">
                                <button class="float-right btn btn-sm btn-primary"> <span class="fa fa-sync" /> </button>
                            </div>
                        </div> -->

                        <div class="ml-3 mt-3 mr-3">
                            <div class="row">
                                <div class="col-md-6">
                                    <h3 class="heading-small text-muted pb-3">Release Manager</h3>
                                </div>
                                <div class="col-md-6">
                                    <button v-if="posRelease.status == 'D'" class="float-right btn btn-sm btn-primary" @click="getLatest"> <span class="fa fa-sync" /> Check for Update </button>
                                    <button v-if="posRelease.status != 'D'" class="float-right btn btn-sm btn-success mr-2" @click="updateConfig"> <span class="fa fa-check" /> Save Configuration </button>
                                    <button v-if="posRelease.status != 'D'" class="float-right btn btn-sm btn-danger mr-2" @click="deploy"> <span class="fa fa-level-up-alt" /> Mark as Closed </button>
                                </div>
                            </div>
                            <!-- {{accounts}} -->
                            <div v-if="posRelease != null">
                                <!-- {{posRelease}} -->
                                <a-card :title="posRelease.meta.name" size="small" style="width: 100%">
                                  <a slot="extra" href="#">
                                      <a-tag v-if="versionDeployed" color="blue"> Version Closed </a-tag> 
                                      <a-switch :disabled="versionDeployed" class="float-right" checked-children="For All" un-checked-children="For All" v-model="accountFilter"/>
                                  </a>
                                   <b>Published at:</b> {{posRelease.meta.published_at}} <br>
                                   <b>Github Node ID:</b> {{posRelease.meta.node_id}} <br>
                                   <b>Github Release URL:</b>  <a :href="posRelease.meta.url">{{posRelease.meta.url}}</a> <br><br>
                                   <a-tag color="green">{{posRelease.meta.tag_name}}</a-tag>
                                   <br>
                                </a-card>
                            </div>

                           
                            <br>
                            
                            <div v-if="accountFilter == false">
                                <div class="row no-gutters">
                                    <div class="col-md-4" style="border-right: 1px solid #e0e0e0; height: 100vh;">
                                        <div class="list-group list-group-flush">
                                            <div class="list-group-item" style="font-size: 14px; height: 55px; background-color: #f7f7f7;">
                                                <div class="row">
                                                    <div class="col-md-6">Accounts</div>
                                                    <div class="col-md-6 float-right">
                                                         <base-button :disabled="versionDeployed" class="float-right ml-1" type="primary" size="sm" @click="openDrawer('a')"><span class="fa fa-plus" /></base-button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="accounts.length > 0">
                                                <div class="list-group-item" style="font-size: 14px; border-radius: 0px;" v-for="(account, index) in accounts" :key="index" :class="[{selected2: selectedAccount == account.id}]">
                                                    <div class="row" @click="setAccount(account)">
                                                       <div class="col-md-8">{{account.account_name}}</div>
                                                       <div class="col-md-4"><span class="ni ni-bold-right float-right" style="padding-bottom: 5px"/></div>
                                                    </div>
                                                 </div>  
                                            </div>
                                            <div v-else>
                                               <a-empty class='mt-5' :image-style="{height: '50px',}" >
                                                   <span slot="description"> Please add accounts on the list. </span>
                                               </a-empty>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4" style="border-right: 1px solid #e0e0e0">
                                        <div class="list-group list-group-flush">
                                            <div class="list-group-item" style="font-size: 14px; height: 55px; background-color: #f7f7f7;">
                                                <div class="row">
                                                    <div class="col-md-6">Site List</div>
                                                    <!-- <div class="col-md-6 float-right"><base-button class="float-right ml-1" type="primary" size="sm" @click="showDrawer('addMenu', selectedMenu, 0)">+ Add Menu</base-button></div> -->
                                                    <div v-if="selectedAccount > 0" class="col-md-6 float-right">
                                                         <base-button :disabled="versionDeployed" class="float-right ml-1" type="primary" size="sm" @click="openDrawer('s')"><span class="fa fa-plus" /></base-button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="selectedAccount > 0" >
                                                <div v-if="sitesDisplay.length > 0 ">
                                                    <div class="list-group-item" style="font-size: 14px; border-radius: 0px;" v-for="(site, index) in sitesDisplay" :key="index" :class="[{selected2: selectedSite == site.id}]">
                                                         <!-- @click="setMainMenu(index)" -->
                                                         <div v-if="selectedAccount > 0" class="row" @click="setSite(site)">
                                                            <div class="col-md-8">{{site.name}}</div>
                                                            <div class="col-md-4"><span class="ni ni-bold-right float-right" style="padding-bottom: 5px"/></div>
                                                         </div>
                                                    </div> 
                                                </div> 
                                                <div v-else>
                                                   <a-empty class='mt-5' :image-style="{height: '50px',}" >
                                                       <span slot="description"> All sites are selected by default for account <b>{{activeAccount.account_name}}</b> </span>
                                                   </a-empty>
                                                </div>
                                            </div>
                                            <div v-else>
                                               <a-empty class='mt-5' :image-style="{height: '50px',}" >
                                                   <span slot="description"> Please select an account.</span>
                                               </a-empty>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="list-group list-group-flush mr-3">
                                            <div class="list-group-item" style="font-size: 14px; height: 55px; background-color: #f7f7f7;">
                                                <div class="row">
                                                    <div class="col-md-6">Terminal List</div>
                                                    <div v-if="selectedSite > 0" class="col-md-6 float-right">
                                                         <base-button :disabled="versionDeployed" class="float-right ml-1" type="primary" size="sm" @click="openDrawer('t')"><span class="fa fa-plus" /></base-button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="selectedSite > 0" >
                                            <div v-if="terminalsDisplay.length > 0">
                                                    <div class="list-group-item mr-3" style="font-size: 14px; border-radius: 0px;" v-for="(terminal, index) in terminalsDisplay" :key="index">
                                                         <!-- @click="setMainMenu(index)" -->
                                                         <div v-if="selectedSite > 0" class="row">
                                                            <div class="col-md-12">{{terminal.name}}</div>
                                                            <!-- <div class="col-md-4"><span class="ni ni-bold-right float-right" style="padding-bottom: 5px"/></div> -->
                                                         </div>
                                                    </div> 
                                                </div> 
                                            <div v-else>
                                               <a-empty class='mt-5' :image-style="{height: '50px',}" >
                                                   <span slot="description"> All terminals are selected by default for site <b>{{activeSite.name}}</b> </span>
                                               </a-empty>
                                            </div>
                                        </div>
                                        <div v-else>
                                            <a-empty class='mt-5' :image-style="{height: '50px',}" >
                                                <span slot="description"> Please select a site. </span>
                                            </a-empty>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <br><br>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>
<script>

import { mapState, mapActions } from 'vuex'
import HTTPRequest from '../../controllers/httpRequest.js'

export default {
    computed: {
       ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters']),
    },
    data() { 
        return {
            accountFilter: true,
            posRelease: {},
            branchFilter: "AB",
            accountOptions: [],
            fetching: false,
            accountIds: [],
            terminalIds: [],
            accountColumns: [
                {
                  title: 'Account Name',
                  dataIndex: 'account_name',
                  scopedSlots: { customRender: 'name' },
                },
                {
                  title: 'Site List',
                  dataIndex: 'operation',
                  scopedSlots: { customRender: 'operation' },
                }
            ],
            activeAccount: null,
            selectedAccount: 0,
            activeSite: null,
            selectedSite: 0,
            sites: [],
            terminals: [],
            accounts: [],
            siteIds: [],
            sitesDisplay: [],
            terminalIds: [],
            terminalsDisplay: [],
            drawerVisible: false,
            type: null,
            versionDeployed: false,
        }
    },
    watch: {
        accountIds: function(){
            this.accounts = []
            this.accountOptions.map(x => {
                if(this.accountIds.includes(x.id))
                    this.accounts.push(x)
            })
        },
        accountFilter: function(){
            if(this.accountFilter == true){
                this.accounts = []
                this.accountIds = []
                this.siteIds = []
                this.terminalIds = []
                this.selectedSite = 0
                this.selectedAccount = 0
                this.activeAccount = 0
                this.activeSite = 0
            }

        }
    },
    methods: {
        updateSelectedSite(){
            this.sitesDisplay = []
            this.activeAccount.sites = []
            this.sites.map(x => {
                if(this.siteIds.includes(x.id)){
                    this.sitesDisplay.push(x)
                    this.activeAccount.sites.push({id: x.id, name: x.name, terminals: []})
                }
            })
            this.onClose()
        },
        onCheckUpdateSiteList(siteId){
            if(this.siteIds.includes(siteId)){
                var index = this.siteIds.indexOf(siteId);
                this.siteIds.splice(index, 1)
            }
            else{
                this.siteIds.push(siteId)
            }
        },
        onCheckAllUpdateSiteList(){
            if(this.siteIds.length == this.sites.length){
                this.siteIds = []
            } else {
                this.siteIds = []
                this.sites.map(x => {
                    this.siteIds.push(x.id)
                })
            }
        },
        updateSelectedTerminal(){
            this.terminalsDisplay = []
            this.activeSite.terminals = []
            this.terminals.map(x => {
                if(this.terminalIds.includes(x.id)){
                    this.terminalsDisplay.push(x)
                    this.activeSite.terminals.push({id: x.id, name: x.name})
                }
            })
             this.activeAccount.sites.map( y => {
                 if(y.id == this.selectedSite){
                     y.terminals = this.activeSite.terminals
                 }
             })
            this.onClose()
        },
        onCheckUpdateTerminalList(terminalId){
            if(this.terminalIds.includes(terminalId)){
                var index = this.terminalIds.indexOf(terminalId);
                this.terminalIds.splice(index, 1)
            }
            else{
                this.terminalIds.push(terminalId)
            }
        },
        onCheckAllUpdateTerminalList(){
            if(this.terminalIds.length == this.terminals.length){
                this.terminalIds = []
            } else {
                this.terminalIds = []
                this.terminals.map(x => {
                    this.terminalIds.push(x.id)
                })
            }
        },
        onClose(){
            this.drawerVisible = false
        },
        openDrawer(type){
           this.type = type
           this.drawerVisible = true
        },
        async setAccount(account){
            this.activeAccount = account
            this.selectedAccount = account.id;
            this.sitesDisplay = []
            this.terminalsDisplay = []
            var sites = await HTTPRequest.getRequest(this.endPoint + "/sites?mode=admin&account_id=" + account.id , null, null)   
            this.sites = sites.data
            if(this.activeAccount.sites != undefined || this.activeAccount.sites != null){
                 this.activeAccount.sites.map( x => { 
                    this.siteIds.push(x.id) && this.sitesDisplay.push(x)
                })    
            }
        },
        async setSite(site){
            this.activeSite = site;
            this.selectedSite = site.id;
            this.terminalsDisplay = []
            var terminals = await HTTPRequest.getRequest(this.endPoint + "/terminals?mode=admin&site_id=" + site.id + "&account_id=" + this.selectedAccount , null, null)   
            this.terminals = terminals.data
            if(this.activeSite.terminals != undefined || this.activeSite.terminals != null){
                 this.activeSite.terminals.map( x => { 
                    this.terminalIds.push(x.id) && this.terminalsDisplay.push(x)
                })
                
            }
        },
        filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
        },
        async handleSearch(value){
            this.fetching = true;
            var accounts = await HTTPRequest.getRequest(this.endPoint + "/accounts/get_valid_accounts?name=" + value , null, null)   
            this.accountOptions = accounts
            this.fetching = false;
        },
        async getLatest(){
            var posRelease = await HTTPRequest.getRequest(this.endPoint + 'pos_releases/get_latest' , null, )
            if(posRelease.warning){
                this.$notification['warning']({
                  message: 'Version Conflict',
                  description: "Current version is not yet marked as deployed. "
                });
                return;
            }
            if(posRelease.info){
                this.$notification['info']({
                  message: 'Version Okay',
                  description: "Current version is up to date."
                });
                return;
            }
            if(posRelease.success){
                this.$notification['success']({
                  message: 'Version Updated',
                  description: "Please configure the new version for release."
                });
                this.posRelease = posRelease.success;
                if(this.posRelease.release_config == null)
                    this.accounts = []
                else
                    this.accounts = this.posRelease.release_config
                this.accountFilter = true
                this.versionDeployed = false
                // this.posRelease = posRelease.success;
                return;
            }
        },
        async updateConfig(){
            var releaseConfig = (this.accountFilter == true) ? null : JSON.stringify(this.accounts)
            var posReleasePayload = { pos_release: { status: 'C', release_config: releaseConfig }}
            var posRelease = await HTTPRequest.putRequest(this.endPoint + 'pos_releases/' + this.posRelease.id , null, posReleasePayload)
            // console.log(posRelease)
            if(posRelease.error == undefined){
                this.$notification['success']({
                  message: 'Configuration Saved',
                  description: "Your release has been configured accordingly. "
                });
            }
        },
        async deploy(){
            var posReleasePayload = { pos_release: { status: 'D' }}
            var posRelease = await HTTPRequest.putRequest(this.endPoint + 'pos_releases/' + this.posRelease.id , null, posReleasePayload)
            // console.log(posRelease)
            if(posRelease.error == undefined){
                this.$notification['success']({
                  message: 'Release Marked as Deployed',
                  description: "Your version is ready for download for all accounts."
                });
            }
            this.getPosRelease()
        },
        async getPosRelease(){
             var posRelease = await HTTPRequest.getRequest(this.endPoint + 'pos_releases/' , null, )
            this.posRelease = posRelease.success
            if(this.posRelease.release_config != null){
                this.accounts = JSON.parse(this.posRelease.release_config)
                this.accountFilter = false
            }
            if(this.posRelease.status == 'D')
                this.versionDeployed = true
        }
    },
    mounted: async function(){
       await this.getPosRelease()
    }
}
</script>

<style>
    .selected2{
        background-color:  #EFF6FF;
        color: #2371CC;
    }
</style>